import React, {useState} from 'react';
import {Divider, Grid} from "@material-ui/core";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import {APP_DOMAIN_PREFIX, quantityUnitsOption} from '../../environment';
import {
  location1,
  mail2,
  placeHolder,
  ShoppingCart,
  shoppingWithin,
  social1,
  social2,
  social3,
  trustedSeller,
  warning
} from "../../assets/images/images";
import HttpService from "../../services/http.service";
import {getUserDataFromLocalStorage, onChangeInput, validateInputs} from "../../services/utils";
import Alert from "../../components/alert";
import {MakeOfferModal} from "../index";
import InputUnit from '../../components/inputWithLabel/inputWithUnit'
import Button from "@material-ui/core/Button";
import {saveAs} from 'file-saver';

const SimpleRow = ({keyText, value}) => {
  return (
    <p className='text-capitalize mt-5 mb-0'><b>{keyText}:</b> {value}</p>
  )
}


function ProductInfoSection(props) {
  const fullDetail = props.fullDetail
  if (!props.product.moq)
    props.product.moq = 1
  let user = getUserDataFromLocalStorage()
  const [modal, setModal] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [state, setState] = useState({
    values: {
      bidId: Number(props?.product?.harvestId),
      price: Number(props?.product?.priceSetByVendor),
      qty: 1,
      ssoId: Number(user?.ssoId),
      unitValue: 'kg',
      quantity: '01',
    },
    errors: {
      bidId: "",
      price: "",
      qty: "",
      ssoId: "",
    },
  });
  const {values, errors} = state
  const makeOffer = (e) => {
    if (user && user.ssoId) {
      e.preventDefault();
      let {bidId, price, qty, ssoId} = values;
      const data = {bidId, price, qty, ssoId}
      let recordedErrors = validateInputs(data);
      if (Object.keys(recordedErrors).length > 0) {
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      } else {
        HttpService.post(`marketplace/bidProduct/bidId/${bidId}/ssoId/${ssoId}/qty/${qty}/price/${price}`).then(res => {
          if (res) {
            if (res?.data?.message == "SUCCESS")
              setSuccess(res?.data?.messageText)
            setTimeout(() => {
              setSuccess("")
              setModal(false)
            }, 8000);
          } else
            setError(res?.data?.messageText)
          setTimeout(() => {
            setError("")
          }, 8000);
        });

      }
    } else {
      props.history.push('/signIn')
    }
  }

  const addCart = (e) => {
    e.preventDefault();
    if (user && user.ssoId) {
      let {bidId, price, qty, ssoId} = values;
      const data = {bidId, price, qty, ssoId}
      let recordedErrors = validateInputs(data);
      if (Object.keys(recordedErrors).length > 0) {
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      } else {
        HttpService.post(`api/save?unitPrice=${price}&productQty=${qty}&harvestId.harvestId=${bidId}&ssoId=${ssoId}`
        ).then(res => {
          if (res?.data?.message == "Success") {
            setSuccess(res?.data?.messageText)
            setTimeout(() => {
              setSuccess("")
              props.history.push('/summary')
            }, 5000);
          } else
            setError(res?.data?.messageText)
          setTimeout(() => {
            setError("")
          }, 8000);
        });
      }
    } else {
      props.history.push('/signIn')
    }
  }
  const downloadImage = (url) => {
    saveAs(url, 'certificate.jpg') // Put your image url here.
  }
  return (
    <Grid>
      {((error || success)) &&
      <Alert type={error ? 'error' : 'success'}
             message={error || success}/>
      }
      <Grid container justify='space-between'>
        <Grid item className=' pt-10 pr-40 ' md={fullDetail ? 8 : 12} style={{minHeight: fullDetail ? 320 : 0}}>
          <Grid container direction='column' className=''>
            <h2
              className='font-30 text-capitalize heading-color'>{props?.product?.harvest || props?.product?.harvestName}</h2>{/* product name*/}

            {/*rating*/}
            {fullDetail && <>
              {/* <div className='display-flex align-items-center'>
                <img src={starFill} width={15}/>
                <img src={starFill} width={15}/>
                <img src={starFill} width={15}/>
                <img src={starFill} width={15}/>
                <span className='text-bold font-14 black-color ml-10'>4.0</span>
              </div> */}
              {/*providedBy*/}
              <Grid className='display-flex align-items-center'>
                {props?.product?.purchasedFrom && <Grid className='display-flex align-items-center  mt-10  '>
                  <img src={placeHolder} width={35}/>
                  <div className='by-container'>
                    <p className='font-12 in-active-color '>Provided By</p>
                    <p className='black-color font-14 text-bold text-capitalize'>{props?.product?.purchasedFrom}</p>
                  </div>
                </Grid>
                }
                {props?.product?.agriBusinessName && <Grid className='display-flex align-items-center ml-20 mt-10'>
                  <img src={placeHolder} width={35}/>
                  <div className='by-container'>
                    <p className='font-12 in-active-color '>Fulfilled By</p>
                    <p className='black-color font-14 text-bold text-capitalize'> {props?.product?.agriBusinessName}</p>
                  </div>
                </Grid>
                }
              </Grid>
            </>}

            <p className=' h-300 black-color font-12 word-break' style={{overflow: 'hidden'}}>{props?.product?.description ||
            "product description "
            }</p>

            {!fullDetail && <div className='mt-20 mb-20'>
              <SimpleRow keyText='crop owner' value='syed form'/>
              <SimpleRow keyText={'Growing Time'} value={'3 months'}/>
              <SimpleRow keyText={'pesticides Used'} value={'ABC pest killer'}/>
            </div>}
          </Grid>
        </Grid>
        {/*certificate section*/}
        {fullDetail && <Grid item md={3}>
          <Grid container justify='flex-end'>
            <Grid container justify='flex-end'>
              <img src={social1} width={20} className='mr-10 cursor-pointer'/>
              <img src={social2} width={20} className='mr-10 cursor-pointer'/>
              <img src={social3} width={20} className='mr-10 cursor-pointer'/>
              <img src={mail2} width={20} className='mr-10 cursor-pointer' style={{
                backgroundColor: 'lightgray',
                padding: 1,
                paddingLeft: 2,
                paddingRight: 2,
                borderRadius: 5
              }}/>
            </Grid>
            {

              props?.product?.certificates && props?.product?.certificates.length > 0 &&
              <button
                onClick={() => downloadImage(APP_DOMAIN_PREFIX + '/userImages/' + props?.product?.certificates[0].certificateImg)}
                className='make-offer-btn text-bold border-radius-10 full-width mt-10 background-transparent'> View
                Certificate
              </button>
            }
            <button className='shopping-within background-transparent'>
              <img src={shoppingWithin} width={15}/>
              <span className='ml-10'>  Shipping within 2 Days</span>
            </button>
            {props.product && (props.product.city || props.product.agriBusinessName) &&
            <Grid container direction='column' className='trusted-seller-container'>
              <div className='display-flex align-items-center'>
                <img src={trustedSeller} alt='' width={15} className='mr-10'/>
                <span>Trusted Seller</span>
              </div>
              <p className='text-bold font-14'
                 style={{marginTop: 10, marginBottom: 7,}}>{props?.product?.agriBusinessName}</p>
              {/* <p className='font-12 black-color m-0'>{props?.product?.contactPerson}</p> */}
              <p className='font-12 black-color display-flex align-items-center mt-10 mb-0'>
                <img src={location1} width={10} className='mr-10'/>
                <span>{props?.product?.city}</span></p>
            </Grid>
            }
          </Grid>
        </Grid>}

      </Grid>
      {!fullDetail &&
      <>
        <Divider/>
        <div className='display-flex align-items-center mt-10'>
          <div className='display-flex flex-column'>
            <h2 className='m-0'>Quantity</h2>
            <InputUnit
              id='qty' value={values.qty}
              onChange={(value, key) => onChangeInput(value, key, state, setState)}
              unitList={quantityUnitsOption}
              unitValue={values.unitValue}
              unitLabel='unitValue'
            />
          </div>
          <div className='display-flex flex-column ml-20'>
            <h2 className='m-0'>Price/Unit</h2>
            <InputUnit
              value={values.price}
              id={'price'}
              onChange={(value, key) => onChangeInput(value, key, state, setState)}
              startEdge={<MonetizationOnIcon/>}
            />
          </div>
        </div>
        <Grid container direction='row' alignItems='center' style={{padding: 0, paddingRight: 0, marginTop: 20}}>
          <Button type="submit" variant="contained" color="primary" className='text-capitalize'
                  onClick={() => {
                    setModal(!modal)
                  }}
          >
            Make offer/ Bid
          </Button>
        </Grid>
      </>
      }
      {/*price section*/}
      {fullDetail &&
      <Grid container direction='row' alignItems='center' style={{padding: 0, paddingRight: 0, marginTop: 20}}>
        <Grid>
          <p
            className='font-22 text-bold black-color m-0'>{props.product && props?.product?.currency + ' '+values.price || `RS. 150`}
            <span
              className='font-10 in-active-color'>/{values.qty} {props.product?.qtyName || props.product?.measure}</span>
          </p>
          <p className='font-10 black-color m-0 display-flex align-items-center'>
            <img src={warning} width={15}/>
            <span
              className='ml-5'> ( Min. Order {props?.product?.moq} {props.product?.qtyName || props.product?.measure})</span>
          </p>
        </Grid>

        <Grid className='qty-counter-container'>
          <button className='heading-color'
                  onClick={() => {
                    if (values.qty > 1 && values.qty > parseInt(props?.product?.moq)) {
                      let value = --values.qty
                      onChangeInput(value, "qty", state, setState)
                      onChangeInput(value * props?.product?.priceSetByVendor, "price", state, setState)
                    }
                  }
                  }>-
          </button>
          <input type={'number'} value={values.qty} min={0}/>
          <button className='heading-color'
                  onClick={() => {
                    let value = ++values.qty
                    onChangeInput(value, "qty", state, setState)
                    onChangeInput(value * props?.product?.priceSetByVendor, "price", state, setState)
                  }}>+
          </button>
        </Grid>
        <Grid>
          <button className=' add-cart-btn ml-20  bg-green  display-flex align-items-center '
                  onClick={(e) => {
                    addCart(e)
                  }}>
            <ShoppingCart/>
            <span className='ml-10 '>Add to cart</span>
          </button>
        </Grid>
        <Grid>
          <button className='add-cart-btn make-offer-btn ml-10 bg-white  heading-color text-bold  '
                  onClick={() => {
                    setModal(!modal)
                  }}
          >Make offer/ Bid
          </button>
        </Grid>
      </Grid>}

      <MakeOfferModal open={modal} setOpen={setModal} state={state} setState={setState} makeOffer={makeOffer}/>
    </Grid>
  );
}

export default ProductInfoSection;
